'use strict';

var React = require('react');

var LanguageStore = require('stores/language');

var Button = React.createClass({
  displayName: 'Button',

  getDefaultProps: function getDefaultProps() {
    return {
      value: '',
      disabled: false,
      className: ''
    };
  },

  render: function render() {
    var props = this.props;

    /* Translations */
    var value = props.value || LanguageStore.translate(props.translationKey + '_button');

    var classes = 'button-component';
    if (props.className) {
      classes += ' ' + props.className;
    }

    var type = props.type || 'button';

    return React.createElement('input', {
      type: type,
      disabled: props.disabled,
      value: value,
      className: classes,
      onClick: this._onClick });
  },

  _onClick: function _onClick(evt) {
    if (this.props.stopPropagation) {
      evt.stopPropagation();
    }

    if (this.props.onClick) {
      var warningMessage = this.props.warningMessage;

      if (warningMessage) {
        if (confirm(warningMessage)) {
          this.props.onClick();
        }
      } else {
        this.props.onClick();
      }
    }
  }

});

module.exports = Button;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/ui/button.js
 **/